import styled from 'styled-components';

export const Wrap = styled.div`
  .header {
    width: 100%;
    position: fixed;
    z-index: 9999;
    background: #80a445;
    padding: 0;
    height: 80px;
    align-content: center;
  }
  .side {
    padding-top: 80px;
    background: #ecffb8;
    box-shadow: 6px 0 10px 0 rgba(0, 0, 0, 0.25);
  }
  .content {
    padding-top: 80px;
    background-color: white;
  }
  @media screen and (max-width: 844px) {
    .header {
      + section.ant-layout {
        flex-direction: column-reverse;
      }
      .right {
        padding-right: 10px;
        > span:not(:last-child) {
          display: none;
        }
      }
    }
    .side {
      width: 100vw !important;
      max-width: 100vw !important;
      padding-top: 20px !important;
      + .ant-layout {
        width: 100vw;
      }
    }
  }
`;

export const Top = styled.div`
  && {
    display: flex;
    align-content: center;
    height: 80px;
  }
  .logo {
    margin-left: 15px;
    height: 45px;
    margin-top: 18px;
  }
  .title {
    margin: 23px 15px;
  }
  .title1 {
    font-size: 20px;
    line-height: 23px;
    margin: 0;
    color: white;
    font-weight: 700;
    letter-spacing: 0.7px;
  }
  .title2 {
    color: white;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    margin: 0;
    letter-spacing: 0.1px;
  }
  .right {
    position: absolute;
    right: 0;
    padding-right: 75px;
    height: 80px;
    display: flex;
    align-items: center;
    color: white;
  }
  .content1 {
    line-height: 21px;
    margin-right: 13px;
    font-weight: 400;
  }
  .content2 {
    line-height: 24px;
    margin-right: 6px;
    font-weight: 700;
  }
  .content3 {
    line-height: 21px;
    font-weight: 400;
    margin-right: 12px;
  }
`;

export const SideBar = styled.div`
  && {
    svg {
      font-size: 1.3em;
    }
    .ant-menu-item {
      margin: 0 !important;
    }
    .menuItem {
      height: 80px;
      background: #ecffb8;
      display: flex;
      align-items: center;
      padding-left: 20px;
      border-left: 10px solid #ecffb8;
    }
    .menuItem1 {
      height: 46px;
      background: #ecffb8;
      display: flex;
      align-items: center;
      padding-left: 20px;
      border-left: 10px solid #ecffb8;
      margin-bottom: 5px !important;
    }
    .last {
      height: 16px;
      border-bottom: 1px solid rgba(196, 196, 196, 1);
    }
    .ant-menu-item-selected {
      background: white !important;
      border-left: 10px solid black;
      padding-left: 20px;
      color: #000c17;
    }
    .triangle {
      margin-left: 30px;
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 14px solid #c1e18d;
    }
    a {
      color: black;
      :hover {
        color: black;
      }
    }
    .ant-menu-submenu-title:hover {
      color: black !important;
    }
    .titleMenuBox {
      padding-top: 10px;
      height: 55px;
      background: #ecffb8;
    }
    .a {
      height: 45px;
      padding-top: 0;
      background: #ecffb8;
    }
    .ant-menu-item:hover {
      color: black;
    }
    .titleMenu {
      height: 30px;
      display: flex;
      align-items: center;
      padding-left: 10px;
      background: #c1e18d;
      p {
        font-weight: 500;
        margin: 0 !important;
      }
    }
    .titleMenu1 {
      margin: 15px 0 5px 10px;
    }
    .ant-menu-item-icon {
      margin-right: 20px !important;
    }
    .titleMenu2 {
      vertical-align: middle;
    }
    .title3 {
      font-weight: 700 !important;
    }
  }
`;
